window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.btn-toggle').length) {
    import('./_toggleBtn.js').then((module) => {
      module.Init();
    });
  }
});
  
export default {}
